import type { TopicSentiment } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

import type { ITopicSentimentTableRow } from "./types";

export const transformData = (data: TopicSentiment[]): ITopicSentimentTableRow[] =>
    data?.map(({ topicName, ...sentiment }) => ({
        topicName,
        sentiment,
    })) ?? [];
